import { Button, Modal, ModalBody, ModalFooter, Spinner } from 'reactstrap';

import { useState } from 'react';
import PickupIcon from './../../../../../../../../assets/custom/pickup.png';

export default function SaveAddressModal({ onCloseHandler, onSaveAddress, locationDetails, updateProfileLoading }) {
  console.log('locationDetails---', locationDetails);
  /* ---------------------------- LOCAL STATES ---------------------------- */
  const [hasValidated, setHasValidated] = useState(false);
  const [addressNickName, setAddressNickName] = useState('');
  const [isOtherAddressType, setIsOtherAddressType] = useState(false);
  const [otherValue, setOtherValue] = useState('');

  return (
    <Modal
      isOpen={true}
      toggle={() => {
        onCloseHandler();
      }}
    >
      <div className="modal-header p-3 pt-4 bg-soft-light">
        <h5 className="modal-title">Save Address</h5>
        <Button
          type="button"
          onClick={() => {
            onCloseHandler();
          }}
          className="btn-close btn-light"
          aria-label="Close"
        ></Button>
      </div>

      <ModalBody>
        <div className="save-address-location-wrapper">
          <div className="location-details-wrapper">
            <div className="location-details-container">
              <div className="location-details-left">
                <div className="pickup-location-icon">
                  <img src={PickupIcon} alt="" className="pickup" />
                </div>
              </div>

              <div className="location-details-right">
                <div className="pickup-location">
                  {locationDetails?.service_type === `Drop` && (
                    <>
                      <div className="location-main-heading">{locationDetails?.from?.address_details?.address}</div>
                      <div className="location-secondary-text">{makeAddress(locationDetails?.from?.address_details)}</div>
                    </>
                  )}

                  {locationDetails?.service_type === `Pickup` && (
                    <>
                      <div className="location-main-heading">{locationDetails?.to?.address_details?.address}</div>
                      <div className="location-secondary-text">{makeAddress(locationDetails?.to?.address_details)}</div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="save-address-controls">
            <div className="field_container ms-2">
              <div className="field_lbl">
                <p>Address Type</p>
              </div>

              <div>
                <select
                  className="field_control"
                  value={addressNickName}
                  onChange={e => {
                    const value = e.target.value;
                    setAddressNickName(value);

                    if (value === `Other`) {
                      setIsOtherAddressType(true);
                    } else {
                      setOtherValue(``);
                      setIsOtherAddressType(false);
                    }
                  }}
                >
                  <option value="">Select Address Type</option>
                  <option value="Home">Home</option>
                  <option value="Work">Work</option>
                  <option value="Other">Other</option>
                </select>
                {hasValidated && addressNickName?.trim() === `` && <div className="validation-error mt-1">{'Please enter a valid address name'}</div>}
              </div>

              {isOtherAddressType && (
                <div className="field_container">
                  <div className="field_lbl">
                    <p>Add Other Address Name</p>
                  </div>

                  <div>
                    <input
                      type="text"
                      className="input-form-control"
                      maxLength={20}
                      name="other"
                      id="other"
                      placeholder="Enter Address name"
                      autoComplete="off"
                      onChange={e => {
                        setOtherValue(e.target.value);
                      }}
                      value={otherValue}
                    />
                    {hasValidated && addressNickName === `Other` && otherValue?.trim() === `` && (
                      <div className="validation-error mt-1">{'Please enter a valid address name'}</div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </ModalBody>

      <ModalFooter className="pb-0">
        <div
          className="modal-footer "
          style={{
            marginLeft: 'auto',
          }}
        >
          <Button
            className="save-address-cta"
            color="primary"
            onClick={() => {
              if (addressNickName?.trim() === ``) {
                setHasValidated(true);
              } else if (addressNickName === `Other` && otherValue?.trim() === ``) {
                setHasValidated(true);
              } else {
                setHasValidated(false);
                onSaveAddress({
                  ...locationDetails,
                  nickname: addressNickName === `Other` ? otherValue : addressNickName,
                });
              }
            }}
          >
            {updateProfileLoading ? (
              <>
                <Spinner size="sm" />
              </>
            ) : (
              <>Save Changes</>
            )}
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
}

const makeAddress = address => [address?.region, address?.country].filter(Boolean).join(', ');
